import React, { FC, useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import styled from 'styled-components';

interface IProps {
  refElement: HTMLElement | null;
  visible: boolean;
  children?: React.ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const SubMenu: FC<IProps> = ({ refElement, visible, children, onMouseEnter, onMouseLeave }: IProps) => {
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
  const [arrowElement, setArrowElement] = useState<HTMLDivElement | null>(null);
  const { styles, attributes, update } = usePopper(refElement, popperElement, {
    modifiers: [{ name: 'arrow', options: { element: arrowElement } }],
  });

  useEffect(() => {
    update?.();
  }, [visible, update]);

  return (
    <Wrapper
      ref={setPopperElement}
      {...attributes.popper}
      visible={visible}
      style={styles.popper}
    >
      <Menu
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Arrow
          ref={setArrowElement}
          style={styles.arrow}
        />
        {children}
      </Menu>
    </Wrapper>
  );
};

export default SubMenu;

const Wrapper = styled.div<{ visible: boolean }>`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  padding: 0 1.25rem;
  padding-top: 2rem;
`;

const Menu = styled.div`
  position: relative;
  background: ${props => props.theme.colors.white};
  border-radius: 0.2rem;
  box-shadow: ${props => props.theme.boxShadow};
  min-width: 17.5rem;
  z-index: 10;
`;

const Arrow = styled.div`
  bottom: 100%;
  border: solid transparent;
  content: '';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: ${props => props.theme.colors.white};
  border-width: 10px;
`;
